import {SRewardPresenter} from "@/app/_components/Coin/SRewardPresenter";
import {DriveUtil} from "@/Master/DriveUtil";
import WebRedeem from "@/Core/Redeem/WebRedeem";
import {RedeemConfigEntity, RedeemRecordInfo, RedeemResult} from "@/Core/Redeem/redeemEntity";
import RedeemData from "@/Core/Redeem/RedeemData";
import {EventType, RdmChannelCode} from "@/Core/Redeem/RedeemPresenter";
import {redeemConst} from "@/Core/Redeem/RedeemConst";
import {HttpResponse} from "@/Fwk/Http/HttpConfig";

import Util from "@/Master/Util";
import {RecordFailState, RedeemRecordState, RedeemResultCode} from "@/Core/Redeem/redeemEnum";
import UserMgr from "@/Core/UserMgr";
import LoginNetManager from "@/Core/Login/LoginNetManager";
import {isEmpty} from "@/app/utils/tool";


export class RedeemManager {

    public static tag = '[Redeem]'
    public static _instance:RedeemManager| null = null;
    public static get Instance(){
        if (this._instance == null) {
            this._instance = new RedeemManager();
            this._instance.InitData();
        }
        return this._instance;
    };

    static selectedChannel: string = '';
    static country: string = '';
    static state: string = '';
    static zipCode: string = '';
    static city: string = '';
    static redeemAccount: string = '';
    private isRequesting: boolean = false;

    private redeemData!: RedeemData;
    private webRedeemInfo!: ResponseRedeemCheckData;

    public InitData() {
        console.log('RedeemManager InitData')
        this.redeemData = new RedeemData();
    }

    get selectedChannel(): string {
        return this.redeemData.selectedChannel;
    }

    set selectedChannel(value: string) {
        this.redeemData.selectedChannel = value;
    }

    get getChannelAccount(): string {
        return this.redeemData.getChannelAccount(this.selectedChannel);
    }

    get country(): string {
        return this.redeemData.country;
    }

    get state(): string {
        return this.redeemData.state;
    }

    get city(): string {
        return this.redeemData.city;
    }

    // 提现帐号是否OK
    get isRedeemAccountOk(): boolean {
        const channel = this.selectedChannel;
        if (channel === RdmChannelCode.CreditCard) {
            return !!(
                channel &&
                this.redeemData.getChannelAccount(channel) &&
                this.redeemData.getChannelCardToken(channel)
            );
        } else {
            return !!(
                channel &&
                this.redeemData.getChannelAccount(channel) &&
                this.redeemData.getObj("country") &&
                this.redeemData.getObj("state") &&
                this.redeemData.getObj("city") &&
                this.redeemData.getObj("zipCode")
            );
        }
    }


    setRedeemAccount(
        account: string,
        channel: string,
        country: string,
        state: string,
        city: string,
        zipCode: string,
        token: string = ""
    ) {
        this.redeemData.selectedChannel = channel;
        this.redeemData.country = country;
        this.redeemData.state = state;
        this.redeemData.city = city;
        this.redeemData.zipCode = zipCode;
        this.redeemData.setChannelAccount(channel, account);
        this.redeemData.setChannelCardToken(channel, token);
        // this.listener.emit(EventType.OnAccountUpdate);
    }

    public DoRedeem(amount: number, onRedeemCallBack: (result: RedeemResult) => void) {
        if (!this.isRedeemAccountOk) {
            const result = new RedeemResult();
            result.code = RedeemResultCode.NotRedeemAccountOk;
            onRedeemCallBack(result);
            return;
        }

        if (amount <= 0) {
            const result = new RedeemResult()
            result.code = RedeemResultCode.NotZero;
            onRedeemCallBack(result);
            return;
        }

        if (amount > UserMgr.getTempUserBaseInfo.scAvailableToRedeem) {
            const result = new RedeemResult()
            result.code = RedeemResultCode.NoAvailableToRedeem;
            onRedeemCallBack(result);
            return;
        }

        // todo 这两个先不做
        // todo 充24提25
        // todo 固定档位
        this.DoRedeemX(amount, onRedeemCallBack);
    }

    public DoRedeemX(amount: number, onRedeemCallBack: (result: RedeemResult) => void) {
        const dollar = DriveUtil.ScToDollar(amount);
        const account = RedeemManager.Instance.getChannelAccount;
        WebRedeem.Instance.RequestRedeemApply(account, dollar, (data: HttpResponse<ResponseRedeemApplyData>) => {
            const result = new RedeemResult();
            // if (Util.isLog) console.log('DoRedeemX', data)
            if (data.code == 200) {
                result.code = RedeemResultCode.Ok;
                result.record = data.data;
            } else {
                result.code = RedeemResultCode.ServerError;
                result.errorMessage = data.message
            }
            onRedeemCallBack(result)
        });
    }

    //获取兑换记录
    static GetRedeemRecord(page: number, pageSize: number, onComplete: (totalPage: number, result: RedeemRecordInfo[]) => void) {
        //先刷新正在提现中的状态
        this.CheckRedeemConfig(() => {
            //再去拉取历史接口，才能匹配正在提现中的订单可取消
            WebRedeem.Instance.RequestRedeemOrderList(page, pageSize, (records) => {
                let recordInfos: RedeemRecordInfo[] = [];
                // var onRedeemId = UserPresenter.Instance.onRedeemId;
                //如果有新的兑换记录，说明兑换成功，否则说明玩家发起了兑换，但服务器并未收到。
                //_tagRedeemOrderId==_firstRedeemOrderId 说明没有新的兑换订单，说明没有兑换成功，需要返还提前预扣的钱

                if (records && records.list && records.list.length > 0) {
                    for (let i = 0; i < records.list.length; i++) {
                        const orderData = records.list[i];
                        const info = this.CreateRecordInfo(orderData);
                        recordInfos.push(info)
                    }
                }

                onComplete(records.totalPage, recordInfos);
            });
        });
    }

    static CreateRecordInfo(orderData: RedeemOrderData): RedeemRecordInfo {
        // const dollar = DriveUtil.ToNormalUnit(orderData.money);
        const dollar = orderData.money;
        return {
            account: orderData.withdrawAccount,
            dateTime: new Date(orderData.createTime).toLocaleString(),
            dollar: dollar,
            fee: orderData.poundage * orderData.money,
            state: this.GetRecordState(orderData.orderId, orderData.orderStatus),
            failState: this.GetFailState(orderData.orderStatus),
            orderStatus: orderData.orderStatus,
            id: orderData.orderId,
            channel: orderData.payType,
        };
    }

    static GetRecordState(orderId: string, orderStatus: string): RedeemRecordState {
        if (orderStatus == "200")
        {
            return RedeemRecordState.Successful;
        }
        else if (this.IsReviewState(orderStatus))
        {
            if (this.IsRecordStateCanCancel(orderId))
            {
                return RedeemRecordState.ReviewCanCancel;
            }
            else
            {
                return RedeemRecordState.ReviewNoCancel;
            }
        }
        else if (orderStatus == "500")
        {
            return RedeemRecordState.Process;
        }
        else
        {
            return RedeemRecordState.Fail;
        }
    }

    //是审核状态
    static IsReviewState(redeemRecordOrderStatus: string) {
        return redeemRecordOrderStatus == "100" || redeemRecordOrderStatus == "101";
    }

    //根据提现中的订单，判断是否可以取消
    static IsRecordStateCanCancel(orderId: string) {
        let inRedeem = this._instance?.webRedeemInfo;
        if (null != inRedeem && null != orderId) {
            if (inRedeem.orderId == orderId) {
                return inRedeem.isWithdraw && inRedeem.isCancel;
            }
        }
        return true;
    }

    static GetFailState(status:string) {
        // ORDER_STATUS_CREATE("100", "创建兑换单（待审核）"),
        // AUTO_AUDIT_FAIL("101", "自动审核不通过"),
        // ORDER_STATUS_PAID("200", "兑换成功"),
        // ORDER_STATUS_REFUSED("300", "拒绝兑换（不退游戏内金额"),
        // ORDER_STATUS_CANCEL("400", "取消兑换（退游戏内金额"),
        // ORDER_STATUS_USER_CANCEL("401", "用户主动取消兑换"),
        // ORDER_STATUS_PAYING("500", "打款中"),
        // ORDER_STATUS_PAID_FAIL("600", "兑换失败"),
        //
        // 100、101、500: 兑换订单创建完成，兑换进行中
        // 200、300：兑换完结状态，用户sc币确认扣除
        // 400、401、600：兑换完结状态，用户sc币退还
        switch (status) {
            case "100":
            case "200":
            case "500":
                return RecordFailState.None;
            case "101":
                return RecordFailState.AutoReject;
            case "300":
                return RecordFailState.PeopleReject;
            case "400":
                return RecordFailState.ThirdPartyReject;
            case "401":
                return RecordFailState.Cancel;
            case "600":
                return RecordFailState.PayFail;
            case "700":
                return RecordFailState.LongLongAgo;
        }

        if (Util.isLog) {
            console.log(`未知的兑换订单状态:${status}`)
        }

        return RecordFailState.None;
    }


    static GetRedeemConfig(onComplete: (res: RedeemConfigEntity) => void) {
        let  entity = new RedeemConfigEntity();
        WebRedeem.Instance.RequestRedeemConfig( (data:ResponseRedeemConfigData[]) => {
            entity.isOk = true;
            entity.typeList = data;
            // var onRedeemId = UserPresenter.Instance.onRedeemId;
            // console.log('获取配置',data);
            onComplete(entity);
            //如果有新的兑换记录，说明兑换成功，否则说明玩家发起了兑换，但服务器并未收到。
            //_tagRedeemOrderId==_firstRedeemOrderId 说明没有新的兑换订单，说明没有兑换成功，需要返还提前预扣的钱
        });
    }

    static CheckRedeemConfig(onComplete: (res: any) => void){
        WebRedeem.Instance.RequestRedeemCheck(redeemConst.peyType, (data:HttpResponse<ResponseRedeemCheckData>) => {
            console.log('CheckRedeemConfig',data);
            if (data.code == 200) {
                if (null != data.data && this._instance instanceof RedeemManager) {
                    this._instance.webRedeemInfo = data.data;
                }
                onComplete(data);
            }else{

            }
        });
    }

    public CancelRedeem(orderId: string, onFinish: (cancel: boolean) => void) {
        //TODO 跟后端确认一下 是不是他那边可以做过滤逻辑只有当前订单能取消
        // let inRedeem = this.webRedeemInfo;
        // if (null == inRedeem || isEmpty(orderId) || (inRedeem.orderId != orderId)) {
        //     if (Util.isLog) console.log(RedeemManager.tag, `取消订单:${orderId} 失败,只能取消当前正在提现的订单`);
        //     onFinish(false);
        //     return;
        // }
        WebRedeem.Instance.RequestRedeemCancel(orderId, data => {
            if (data.code == 200 && null != data.data) {
                let orderStatus = data.data.orderData.orderStatus;
                let cancelResult = data.data.cancelResult;
                if (cancelResult) {
                    onFinish(true);
                    LoginNetManager.Instance.UpdateUserBaseInfo(t => {
                        onFinish(true);
                        RedeemManager.CheckRedeemConfig(a => {
                        });
                    })
                    return;
                }
            }
            onFinish(false);
        })
    }

}